import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const disabledPrimaryButtonStyle = css`
  background-color: ${colors['@primary-color-disabled']};
  border-color: ${colors['@primary-color-disabled']};
  color: ${colors['@primary-color-disabled-text']};
`;

const disabledPrimaryDangerousButtonStyle = css`
  border-color: ${colors['@error-color-disabled']};
  background-color: ${colors['@error-color-background']};
  color: ${colors['@error-color-disabled']};
`;

const ghostDangerousButtonStyle = css`
  background-color: ${colors['@white']};

  &:not([disabled]):hover {
    background-color: ${colors['@error-color']};
    border-color: ${colors['@error-color']};
    color: ${colors['@white']};
  }
`;

const rootStyle = css`
  &.ant-btn {
    &-primary {
      &[disabled] {
        ${disabledPrimaryButtonStyle}
      }
    }

    &.ant-btn-dangerous {
      &[disabled] {
        ${disabledPrimaryDangerousButtonStyle}
      }

      &.ant-btn-background-ghost {
        ${ghostDangerousButtonStyle}
      }
    }
  }
`;

// `classNames.root`, not `className`: antd skips semantic classNames for `_skipSemantic` callers
// (`button/Button.js:226`), i.e. FloatButton — a `className` would repaint it too.
const buttonConfig: ConfigProviderProps['button'] = { classNames: { root: rootStyle } };

export default buttonConfig;
